export default class LanguageControl {

    private static EnRusArray: { en: string, rus: string }[] = [
        //lower
        { en: "q", rus: "й" },
        { en: "w", rus: "ц" },
        { en: "e", rus: "у" },
        { en: "r", rus: "к" },
        { en: "t", rus: "е" },
        { en: "y", rus: "н" },
        { en: "u", rus: "г" },
        { en: "i", rus: "ш" },
        { en: "o", rus: "щ" },
        { en: "p", rus: "з" },
        { en: "[", rus: "х" },
        { en: "]", rus: "ъ" },
        { en: "a", rus: "ф" },
        { en: "s", rus: "ы" },
        { en: "d", rus: "в" },
        { en: "f", rus: "а" },
        { en: "g", rus: "п" },
        { en: "h", rus: "р" },
        { en: "j", rus: "о" },
        { en: "k", rus: "л" },
        { en: "l", rus: "д" },
        { en: ";", rus: "ж" },
        { en: "\'", rus: "э" },
        { en: "z", rus: "я" },
        { en: "x", rus: "ч" },
        { en: "c", rus: "с" },
        { en: "v", rus: "м" },
        { en: "b", rus: "и" },
        { en: "n", rus: "т" },
        { en: "m", rus: "ь" },
        { en: ",", rus: "б" },
        { en: ".", rus: "ю" },
        { en: "/", rus: "." },
        //UPPER
        { en: "Q", rus: "Й" },
        { en: "W", rus: "Ц" },
        { en: "E", rus: "У" },
        { en: "R", rus: "К" },
        { en: "T", rus: "Е" },
        { en: "Y", rus: "Н" },
        { en: "U", rus: "Г" },
        { en: "I", rus: "Ш" },
        { en: "O", rus: "Щ" },
        { en: "P", rus: "З" },
        { en: "{", rus: "Х" },
        { en: "}", rus: "Ъ" },
        { en: "A", rus: "Ф" },
        { en: "S", rus: "Ы" },
        { en: "D", rus: "В" },
        { en: "F", rus: "А" },
        { en: "G", rus: "П" },
        { en: "H", rus: "Р" },
        { en: "J", rus: "О" },
        { en: "K", rus: "Л" },
        { en: "L", rus: "Д" },
        { en: ":", rus: "Ж" },
        { en: "\"", rus: "Э" },
        { en: "Z", rus: "Я" },
        { en: "X", rus: "Ч" },
        { en: "C", rus: "С" },
        { en: "V", rus: "М" },
        { en: "B", rus: "И" },
        { en: "N", rus: "Т" },
        { en: "M", rus: "Ь" },
        { en: "<", rus: "Б" },
        { en: ">", rus: "Ю" },
    ];

    /** lang - new language, str - value string */
    private static switchTo(lang: string, str: string) {
        if (!str) return "";
        let resStr = "";
        const newLang = lang == 'rus' ? 'en' : 'rus';
        for (let i = 0; i < str.length; i++) {
            const char = str.charAt(i);

            const codeLimit = newLang == "rus" ? v => v < 130 : v => v > 1000; // если код знака в нужном диапазоне, то и исправлять его ни к чему
            if (codeLimit(char.charCodeAt(0))) {
                resStr += char;
            }

            else {
                const newChar = this.EnRusArray.find(x => x[newLang] == char);
                if (newChar) resStr += newChar[lang];
                else resStr += char;
            }
        }
        return resStr;
    }

    public static EnToRus(str: string): string {
        return this.switchTo('rus', str);
    }
    public static RusToEn(str: string): string {
        return this.switchTo('en', str);
    }
}